"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var CreateReactComponentFromStencil_1 = require("../../../utils/CreateReactComponentFromStencil");

var IconLink_1 = require("../../molecules/IconLink");

var ProcessNavigation_1 = require("../ProcessNavigation");

var ProcessPageInternal = CreateReactComponentFromStencil_1.createReactComponentFromStencil("lsg-processpage");

var ProcessPage = function ProcessPage(_a) {
  var iconLinks = _a.iconLinks,
      navigationLinks = _a.navigationLinks,
      navigationLabel = _a.navigationLabel,
      children = _a.children,
      className = _a.className,
      props = __rest(_a, ["iconLinks", "navigationLinks", "navigationLabel", "children", "className"]);

  return React.createElement(ProcessPageInternal, __assign({}, props, {
    className: utils_1.DomUtils.cleanupClassNames([className, CSSPrefix_1.lsgPre + "pagecontainer__mandatorysidenavigation"]),
    hasMenu: !!navigationLinks
  }), React.createElement(IconLink_1.IconLinkGroup, {
    direction: IconLink_1.IconLinkGroup.Directions.COLLAPSE_SM,
    htmlAttrs: {
      slot: "icon-links"
    }
  }, iconLinks), navigationLinks && React.createElement(ProcessNavigation_1.ProcessNavigation, {
    label: navigationLabel,
    slot: "navigation"
  }, navigationLinks), children);
};

exports.ProcessPage = ProcessPage;